import { __assign, __rest } from "tslib";
import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { default as MuiDialogActions, } from '@material-ui/core/DialogActions';
var useStyles = makeStyles(function () {
    return createStyles({
        tertiaryContent: {
            marginRight: 'auto',
        },
    });
});
export var DialogActions = React.forwardRef(function (props, ref) {
    var tertiaryContent = props.tertiaryContent, children = props.children, other = __rest(props, ["tertiaryContent", "children"]);
    var classes = useStyles(props);
    return (React.createElement(MuiDialogActions, __assign({ ref: ref }, other),
        tertiaryContent && React.createElement("div", { className: classes.tertiaryContent }, tertiaryContent),
        children));
});
export default DialogActions;
//# sourceMappingURL=DialogActions.js.map